(() => {
  // app/scripts/common/component/productForm.js
  var {
    storage,
    getFitmentTableData
  } = window.ymmUtils;
  !window.customElements.get("product-form") && customElements.define("product-form", class extends HTMLElement {
    constructor() {
      super();
      this.querySelector("product-cart-form") && window.addEventListener("scroll", this.onScroll.bind(this));
      if (this.querySelector(".ymm-config")) {
        this.config = JSON.parse(this.querySelector(".ymm-config")?.textContent);
      }
      this.myGarage = JSON.parse(document.querySelector("my-garage script[type*=json]").textContent);
      this.customerId = this.myGarage.customerId;
      window.addEventListener("fitment:refresh", () => this.handleProductFit());
    }
    connectedCallback() {
      this.scriptElement = this.querySelector('script[type="application/json"].object-product');
      this.scriptProductSelect = this.querySelector('script[type="application/json"].object-product-select');
      this.JSON = this.scriptElement ? JSON.parse(this.scriptElement.textContent).product : window.theme.product;
      this.jsonProductSelect = this.scriptProductSelect ? JSON.parse(this.scriptProductSelect.textContent).productSelect : window.theme.productSelect;
      this.currentVariant = this.jsonProductSelect;
      this.linkOptions();
      this.addEventListener("change", this.onChange.bind(this));
      this.template = this.querySelector("[data-variant-template]")?.content || null;
      this.container = this.closest("popup-component") || this.closest(".shopify-section");
      this.findVariantFitMent();
      this.changePositionOption();
      if (window.location.href.includes("barcode")) {
        const barcode = window.location.href.split("barcode=")[1];
        const cur_target = this.template.querySelector(`[data-upc="${barcode}"]`);
        this.currentVariant = this.JSON.variants.find((variant) => variant.id == cur_target.dataset.variantId);
        this.updateMedia();
        let cur_inputs = document.querySelectorAll(".variants-wrapper input");
        cur_inputs.forEach((e) => {
          if (e.value == this.currentVariant.options[0] || e.value == this.currentVariant.options[1] || e.value == this.currentVariant.options[2] || e.value == this.currentVariant.options[3]) {
            e.checked = true;
          } else {
            e.checked = false;
          }
        });
        if (this.closest(".shopify-section-main-product")) {
          this.updateURL();
        }
        if (this.currentVariant) {
          this.updateId();
          this.updateVariant(this.currentVariant.id);
          this.handleProductFit(this.currentVariant.id);
          this.changePositionOption();
          this.setAvailable(this.currentVariant.available);
        } else {
          this.setUnavailable();
        }
      }
      const { debounceTime } = theme;
      const debouncedUpdateMedia = debounceTime(() => {
        const swiperComponent = this.container.querySelector(".js-slider-main swiper-component");
        if (swiperComponent?.swiper) {
          this.updateMedia();
        } else {
          swiperComponent?.addEventListener("swiper:mounted", () => {
            this.updateMedia();
          });
        }
      }, 100);
      debouncedUpdateMedia();
      this.handleProductFit();
    }
    changePositionOption() {
      const main = this.querySelector(".product-subtitle");
      if (!main)
        return;
      [].map.call(main.children, Object).sort(function(a, b) {
        return +a.id.match(/\d+/) - +b.id.match(/\d+/);
      }).forEach(function(elem) {
        main.appendChild(elem);
      });
    }
    onChange(event) {
      const target = event.target;
      if (target.name == "quantity" && this.container.querySelector("product-sticky-component quantity-input"))
        this.container.querySelector("product-sticky-component quantity-input").setValue = target.value;
      if (!target.classList.contains("js-variant-change"))
        return;
      let index = +target.name.replace(/[^\d]/g, "");
      for (var i = index + 1; i <= this.JSON.options.length; i++) {
        this.updateOptionsInSelector(i);
      }
      if (!this.getVariant())
        return;
      this.updateMedia();
      if (this.closest(".shopify-section-main-product")) {
        this.updateURL();
      }
      if (this.currentVariant) {
        this.updateId();
        this.updateVariant(this.currentVariant.id);
        this.handleProductFit(this.currentVariant.id);
        this.changePositionOption();
        this.setAvailable(this.currentVariant.available);
      } else {
        this.setUnavailable();
      }
      this.closest(".product-container")?.classList.toggle("variant-soldout", !this.currentVariant?.available || false);
      this.closest("product-card")?.classList.toggle("card__soldout", !this.currentVariant?.available || false);
      const { swatchId } = target.dataset;
      this.querySelector(swatchId)?.classList.remove("active");
      document.dispatchEvent(new CustomEvent("variant-change"));
    }
    onScroll() {
      const cartForm2 = this.querySelector("product-cart-form");
      const headerSticky = document.querySelector("sticky-header");
      const headerStickyBottom = headerSticky?.getBoundingClientRect().bottom;
      if (cartForm2.offsetTop + cartForm2.clientHeight <= window.scrollY + headerStickyBottom) {
        document.body.classList.add("show-pdp-sticky");
        return;
      }
      document.body.classList.remove("show-pdp-sticky");
    }
    updateId() {
      if (this.currentVariant && this.currentVariant.available) {
        const masterID = this.querySelector('[name="id"]');
        masterID.tagName == "SELECT" && (masterID.value = this.currentVariant.id);
      }
    }
    getCurrentOptions() {
      let currentOptions = [];
      this.JSON.options.forEach((option, index) => {
        let optionName = `[name="option${index + 1}"]`;
        if (this.querySelector(optionName)?.tagName == "INPUT") {
          currentOptions.push(this.querySelector(optionName + ":checked")?.value);
        } else {
          currentOptions.push(this.querySelector(optionName)?.value);
        }
      });
      return currentOptions;
    }
    getVariant() {
      const options = this.getCurrentOptions();
      this.currentVariant = this.JSON.variants.find((variant) => {
        return !variant.options.map((option, index) => {
          return options[index] === option;
        }).includes(false);
      });
      if (!this.currentVariant) {
        let selectOptions = Array.from(
          this.querySelectorAll("select[name*=option], input[name*=option]:checked")
        ).filter((i) => i != null);
        if (this.JSON.options.length != selectOptions.length)
          return false;
      }
      return true;
    }
    updateURL() {
      if (!this.currentVariant)
        return;
      window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateContent(html) {
      const convertHtml = new DOMParser().parseFromString(html, "text/html");
      const template = convertHtml.querySelector(".variant-template");
      Array.from(document.querySelectorAll(".jsVariantUpdate")).forEach((node) => {
        const { updateId } = node.dataset;
        if (!updateId.includes(this.dataset.formId))
          return;
        const target = template?.querySelector(`.jsVariantUpdate[data-update-id="${node.dataset.updateId}"]`);
        if (updateId.includes("productGallery") && node.querySelector(".js-slider-main").dataset.productId == target.querySelector(".js-slider-main").dataset.productId)
          return;
        node.innerHTML = target?.innerHTML || "";
        target && (node.className = target.className);
      });
      window.dispatchEvent(
        new CustomEvent("description:update", {
          detail: { currentVariant: this.currentVariant }
        })
      );
    }
    updateMedia() {
      if (!this.currentVariant?.featured_media)
        return;
      const swiperInstance = this.container.querySelector(".js-slider-main swiper-component")?.swiper;
      if (swiperInstance) {
        const extractImageName = (url) => url.split("files/")[1].split(".")[0];
        const imgCurrentSrc = extractImageName(this.currentVariant.featured_image.src);
        swiperInstance.slides.some((slide, index) => {
          const slideImage = slide.querySelector("img");
          if (!slideImage)
            return false;
          const imgSrc = slideImage.src;
          if (imgSrc.includes(imgCurrentSrc)) {
            swiperInstance.slideTo(index);
            return true;
          }
          return false;
        });
      }
    }
    setAvailable(isAvailable) {
      this.querySelectorAll(".add-to-cart")?.forEach((item) => {
        item.disabled = !isAvailable;
        item.classList.toggle("btn-unavailable", !isAvailable);
        item.innerHTML = theme.string.addToCart;
      });
      let btnATCSticky = this.closest(".shopify-section").querySelector("product-sticky-component .add-to-cart");
      if (btnATCSticky) {
        btnATCSticky.classList.toggle("btn-unavailable", !isAvailable);
      }
    }
    setUnavailable() {
      this.querySelectorAll(".add-to-cart")?.forEach((item) => {
        item.innerHTML = theme.string.unavailable;
        item.disabled = true;
        item.classList.add("btn-unavailable");
        item.classList.remove("none");
      });
      let btnATCSticky = this.closest(".shopify-section").querySelector("product-sticky-component .add-to-cart");
      if (btnATCSticky) {
        btnATCSticky.innerHTML = theme.string.unavailable;
        btnATCSticky.classList.add("btn-unavailable");
      }
      this.querySelectorAll('.jsVariantUpdate[data-update-id*="price"]')?.forEach((item) => {
        item.innerHTML = `<span class="price">${theme.string.unavailable}</span>`;
      });
      if (this.querySelector(".product-inventory")) {
        this.querySelector(".product-inventory").innerHTML = "";
      }
      if (this.querySelector(".product-subtitle")) {
        this.querySelector(".product-subtitle").innerHTML = "";
      }
    }
    linkOptions() {
      this.optionsMap = {};
      this.availableOptions = {};
      for (var i = 0; i < this.JSON.variants.length; i++) {
        const variant = this.JSON.variants[i];
        this.JSON.options.forEach((option, index) => {
          let key = index == 0 ? "root" : variant.options.slice(0, index).join(" / ");
          this.optionsMap[key] = this.optionsMap[key] || [];
          this.optionsMap[key].push(variant.options[index]);
          this.optionsMap[key] = [...new Set(this.optionsMap[key])];
          if (variant.available) {
            this.availableOptions[key] = this.availableOptions[key] || [];
            this.availableOptions[key].push(variant.options[index]);
            this.availableOptions[key] = [...new Set(this.availableOptions[key])];
          }
        });
      }
      if (!Array.from(this.querySelectorAll("select[name*=option], input[name*=option]:checked")).filter(
        (i2) => i2 != null
      ).length)
        return;
      this.JSON.options.forEach((value, index) => {
        this.updateOptionsInSelector(index + 1);
      });
    }
    updateOptionsInSelector(index) {
      const listSelectors = this.JSON.options.map((value, i) => {
        const currentSelected = [...this.querySelectorAll(`select[name=option${i + 1}], input[name=option${i + 1}]:checked`)].find((i2) => i2 != null);
        return currentSelected?.value || "";
      });
      const key = index == 1 ? "root" : listSelectors.slice(0, index - 1).join(" / ");
      const selector = [...this.querySelectorAll(`select[name=option${index}], input[name=option${index}]:checked`)].find((i) => i != null);
      const availableOptions = this.optionsMap[key] || [];
      const optionsValid = this.availableOptions[key] || [];
      const initialValue = selector?.value || "null";
      if (!selector)
        return;
      if (selector.tagName == "SELECT") {
        Array.from(selector.querySelectorAll("option")).forEach((option) => {
          availableOptions.includes(option.value) ? option.removeAttribute("hidden") : option.setAttribute("hidden", "");
        });
        if (availableOptions.length && !availableOptions.includes(initialValue)) {
          selector.value = availableOptions[0];
        }
      } else {
        Array.from(this.querySelectorAll(`[name=${selector.name}]`)).forEach((input) => {
          input.classList.toggle("disabled", !optionsValid.includes(input.value));
        });
        if (availableOptions.length && !availableOptions.includes(initialValue)) {
          const tempInput = document.createElement("input");
          tempInput.type = "text";
          tempInput.value = availableOptions[0];
          const findAvailableInput = Array.from(this.querySelectorAll(`[name=${selector.name}]`)).find(
            (input) => input.value == tempInput.value
          );
          findAvailableInput && (findAvailableInput.checked = true);
        }
      }
    }
    getProductHandle() {
      const path = window.location.pathname;
      const match = path.match(/\/products\/([^/?]+)/);
      return match ? match[1] : null;
    }
    async updateVariant() {
      try {
        const response = await this.fetchVariantDetails(this.currentVariant.id);
        if (response.ok) {
          const html = await response.text();
          this.updateContent(html);
        } else {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
      } catch (error) {
        console.error("OEW Variant Switcher: Error updating variant", error);
      }
    }
    async fetchVariantDetails(variantId) {
      const productHandle = this.getProductHandle();
      const sectionId = "product-variant-details";
      const url = `/products/${productHandle}?variant=${variantId}&section_id=${sectionId}`;
      return fetch(url, {
        method: "GET",
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      });
    }
    async handleProductFit(variantId = this.currentVariant?.id, fitmentDataDefault = null) {
      const productVendor = this.JSON.vendor.toLowerCase().trim();
      const btnAtc = this.querySelector("product-cart-form .add-to-cart");
      const btnAtcContent = btnAtc ? btnAtc.innerText.toLowerCase().trim() : "";
      const atcContentDefault = theme.string.addToCart.toLowerCase().trim();
      if (variantId != null) {
        let btnRedirects = this.querySelectorAll(".js-btn-redirect");
        console.log("fitmentDataDefault", fitmentDataDefault);
        const fitmentData = fitmentDataDefault ? fitmentDataDefault : await getFitmentTableData(this.config, [variantId]);
        this.hasFitment = await this.isFitment(fitmentData, variantId);
        if (this.selectedYMM || this.selectedYMM?.value) {
          let productNote = `Fitment: ${this.year} ${this.make} ${this.model}`;
          btnRedirects.forEach((btn) => {
            let btnContent = this.year + " " + this.make + " " + this.model;
            btn.innerHTML = btnContent.replaceAll("+", " ");
          });
          if (this.hasFitment) {
            this.querySelector(".product-fit_match")?.classList.add("active");
            this.querySelector(".product-fit_nomatch")?.classList.remove("active");
            this.querySelector(".product-fit_specific")?.classList.remove("active");
            this.querySelector("product-cart-form .js-product-note").value = productNote;
          } else {
            this.querySelector(".product-fit_match")?.classList.remove("active");
            this.querySelector(".product-fit_nomatch")?.classList.add("active");
            this.querySelector(".product-fit_specific")?.classList.remove("active");
            this.querySelector("product-cart-form .js-product-note").value = "";
          }
          if (productVendor == "4play wheels" && btnAtcContent == theme.strings.select_vehicle_before_atc.toLowerCase().trim()) {
            this.querySelector("product-cart-form .add-to-cart").innerHTML = theme.string.addToCart;
            this.querySelector("product-cart-form .add-to-cart").disabled = false;
          }
          return;
        }
      }
      this.querySelector(".product-fit_match")?.classList.remove("active");
      this.querySelector(".product-fit_nomatch")?.classList.remove("active");
      this.querySelector(".product-fit_specific")?.classList.add("active");
      if (productVendor == "4play wheels" && btnAtcContent == atcContentDefault) {
        this.querySelector("product-cart-form .add-to-cart").innerHTML = theme.strings.select_vehicle_before_atc;
        this.querySelector("product-cart-form .add-to-cart").disabled = true;
      }
      const productNoteField = this.querySelector("product-cart-form .js-product-note");
      if (productNoteField) {
        productNoteField.value = "";
      }
    }
    // async handleProductFit(variantId) {
    //   let btnRedirects = this.querySelectorAll(".js-btn-redirect");
    //   this.hasFitment = await this.isFitment(variantId);
    //   if (this.selectedYMM || this.selectedYMM?.value) {
    //     btnRedirects.forEach(btn => {
    //       let btnContent = this.year + ' ' + this.make + ' ' + this.model
    //       btn.innerHTML = btnContent.replaceAll('+', ' ');
    //     })
    //     if (this.hasFitment) {
    //       this.querySelector('.product-fit_match')?.classList.add('active');
    //       this.querySelector('.product-fit_nomatch')?.classList.remove('active');
    //       this.querySelector('.product-fit_specific')?.classList.remove('active');
    //     } else {
    //       this.querySelector('.product-fit_match')?.classList.remove('active');
    //       this.querySelector('.product-fit_nomatch')?.classList.add('active');
    //       this.querySelector('.product-fit_specific')?.classList.remove('active');
    //     }
    //   } else {
    //     this.querySelector('.product-fit_match')?.classList.remove('active');
    //     this.querySelector('.product-fit_nomatch')?.classList.remove('active');
    //     this.querySelector('.product-fit_specific')?.classList.add('active');
    //   }
    //   // this.renderFitmentList();
    // }
    getCurrentYMM(dbName, storeName, key) {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName);
        request.onerror = () => reject(request.error);
        request.onsuccess = () => {
          const db = request.result;
          const tx = db?.transaction(storeName, "readonly");
          const store = tx.objectStore(storeName);
          const getReq = store.get(key);
          getReq.onerror = () => reject(getReq.error);
          getReq.onsuccess = () => resolve(getReq.result);
        };
      });
    }
    async isFitment(fitmentData, id) {
      let hasFitmentList = false;
      let variantId = id;
      let variantSelected;
      let ymms;
      if (this.customerId) {
        this.selectedYMM = storage.get("currentVehicle");
      } else {
        await this.getCurrentYMM("localforage", "keyvaluepairs", "YMMQueries").then((value) => {
          this.selectedYMM = value;
        }).catch((error) => {
          console.error("Error:", error);
        });
      }
      const result = fitmentData?.find((p) => p._source.variants.some((v) => String(v.id) === String(id)));
      const variantList = result?._source?.variants;
      if (!variantId || isNaN(variantId)) {
        this.getVariant();
        variantList?.length === 1 ? variantId = this.dataset.productSelectId : variantId = this.currentVariant?.id;
      }
      if (variantList) {
        variantSelected = variantList?.filter((variant) => variant.id == variantId);
        ymms = variantSelected[0]?.ymms;
      }
      if (this.selectedYMM || this.selectedYMM?.value) {
        const dataFilter = this.selectedYMM?.value?.split("&") || this.selectedYMM?.split("&");
        this.year = dataFilter[0]?.split("=")[1].replaceAll("+", " ");
        this.make = dataFilter[1]?.split("=")[1].replaceAll("+", " ");
        this.model = dataFilter[2]?.split("=")[1].replaceAll("+", " ");
        if (ymms && ymms.length > 0) {
          hasFitmentList = ymms.some((i) => {
            return i.year == this.year && i.make == this.make && i.model == this.model;
          });
        }
        this.fitmentItemList = ymms;
      }
      return hasFitmentList;
    }
    async findVariantFitMent() {
      const variantIds = [...new Set(this.JSON.variants.map((v) => v.id))];
      const fitmentData = await getFitmentTableData(this.config, variantIds);
      let variantId = null;
      const searchParams = new URLSearchParams(window.location.search);
      const id = searchParams.get("variant");
      if (id) {
        variantId = id;
      } else {
        for (const variant of this.JSON.variants) {
          const hasMatch = await this.isFitment(fitmentData, variant.id);
          if (hasMatch) {
            variantId = variant.id;
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.set("variant", variant.id);
            window.history.replaceState({}, "", currentUrl.toString());
            this.currentVariant = variant;
            if (this.template) {
              this.updateVariant(this.currentVariant.id);
            }
            this.updateId();
            this.updateMedia();
            variant.options.forEach((optionValue, index) => {
              const selector = this.querySelector(`[name="option${index + 1}"]`);
              if (selector.tagName === "SELECT") {
                selector.value = optionValue;
              } else {
                const radio = this.querySelector(`[name="option${index + 1}"][value="${optionValue}"]`);
                radio.checked = true;
              }
            });
            break;
          }
        }
      }
      if (variantId) {
        this.handleProductFit(+variantId, fitmentData);
      }
    }
    // async renderFitmentList(){
    //   this.hasFitment = await this.isFitment();
    //   let listMake = document.querySelector('.fitment-list');
    //   if(listMake)
    //     listMake.innerHTML = "";
    //   this.fitmentItemList?.forEach(item=>{
    //     const { year, make, model} = item;
    //     let li = document.createElement("li");
    //     let aTag = document.createElement("a");
    //     aTag.innerHTML = [year, make, model].filter(Boolean).join(" ");
    //     aTag.setAttribute("data-filter-value", [year, make, model].filter(Boolean).join("__"),);
    //     // aTag.href = theme.routes.allProductsCollectionUrl;
    //     li.append(aTag);
    //     listMake.append(li);
    //   })
    // }
  });

  // app/scripts/common/component/productSticky.js
  var customElementsName = "product-sticky-component";
  !window.customElements.get(customElementsName) && window.customElements.define(customElementsName, class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", ({ target }) => {
        target.name == "quantity" && this.updateQty(target.value);
      });
      document.addEventListener("click", (e) => {
        if (e.target.closest(".product-cart_button")?.querySelector(".jsBtnNotify")) {
          console.log("click");
          var element = document.querySelector(".block-back-in-stock");
          var headerOffset = 244;
          var elementPosition = element.getBoundingClientRect().top;
          var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        }
      });
    }
    updateQty(value) {
      const form = document.getElementById(this.dataset.formId);
      form.querySelector("quantity-input").setValue = value;
    }
  });

  // app/scripts/common/component/expandComponent.js
  var customElementsName2 = "expand-component";
  !window.customElements.get(customElementsName2) && window.customElements.define(customElementsName2, class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const paragraph = this.querySelector(".product-disclaimer-wrapper");
      const readMoreBtn = this.querySelector(".btn-show-more");
      const clone = paragraph.cloneNode(true);
      clone.style.visibility = "hidden";
      clone.style.position = "absolute";
      clone.style.maxHeight = "none";
      this.appendChild(clone);
      if (clone.scrollHeight > this.clientHeight) {
        readMoreBtn.style.display = "inline";
      }
      readMoreBtn?.addEventListener("click", () => {
        this.classList.toggle("expanded");
        readMoreBtn.textContent = this.classList.contains("expanded") ? "Read Less" : "Read More";
      });
      this.removeChild(clone);
    }
  });

  // app/scripts/common/component/bulkOrder.js
  !window.customElements.get("bulk-order") && window.customElements.define("bulk-order", class bulkOrder extends cartForm {
    constructor() {
      super();
      this.btn_submit = this.querySelector(".jsATC");
      this.btn_submit.addEventListener("click", () => {
        this.AddtoCart();
      });
      this.instock_products = this.querySelectorAll(".variant-item.instock");
      this.querySelectorAll(".variant-item").forEach((variantItem) => {
        const input = variantItem.querySelector("quantity-input input");
        input.addEventListener("input", () => {
          if (input.value > 0) {
            variantItem.classList.add("active");
          } else {
            variantItem.classList.remove("active");
          }
          this.updateTotal();
        });
        input.addEventListener("blur", () => {
          if (!input.value) {
            input.value = 0;
          }
        });
      });
    }
    updateTotal() {
      let totalPrice = 0;
      let totalQuantity = 0;
      this.querySelectorAll(".variant-item").forEach((variant) => {
        const inputValue = parseFloat(variant.querySelector("input").value);
        const variantPrice = parseFloat(variant.querySelector(".price")?.dataset.value);
        if (inputValue > 0) {
          totalQuantity = totalQuantity + inputValue;
          totalPrice = totalPrice + variantPrice * inputValue;
        }
      });
      this.querySelector(".jsTotalPrice price-component").set(totalPrice);
      this.querySelector(".jsTotalQuantity").innerHTML = totalQuantity;
    }
    async AddtoCart() {
      const items = [];
      this.instock_products.forEach((e) => {
        var quanity = parseInt(e.querySelector(".quantity__input").value);
        if (quanity > 0) {
          items.push({
            id: e.dataset.id,
            quantity: quanity
          });
        }
      });
      let formData = {
        items
      };
      formData = { ...formData, sections: this.sectionList() };
      if (items.length > 0) {
        this.postCart("add", JSON.stringify(formData), (resp) => {
        }, false);
      } else {
        alert("Please increase the product quantity");
      }
    }
    onUpdating(response) {
      if (!response.isSuccess)
        return;
      ["cart-drawer-component", "cart-component"].forEach((section) => {
        const sectionEl = document.querySelector(section);
        if (sectionEl) {
          sectionEl.refresh = response.sections;
          sectionEl.open = true;
        }
      });
    }
  });
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".jsBtnBulkOrder"))
      return;
    e.preventDefault();
    document.querySelector("#bulkOrder").open();
    console.log(e.target);
  });
})();
